import { useHttp } from '@d5/hooks'
import { ID5MetaType } from '@d5/ui'

import { LoginType, LoginResponseType } from '@/types'

export const useLogin = (data: LoginType) =>
  useHttp<LoginResponseType>({
    url: '/users/sessions',
    method: 'post',
    data,
  })

export const usePermissions = (user_id: number | string) =>
  useHttp<{ meta: ID5MetaType; data: { permissions: Array<string> } }>({
    url: `/users/${user_id}/permissions`,
  })
